import { render, staticRenderFns } from "./create-customer.vue?vue&type=template&id=6d1af652&scoped=true"
import script from "./create-customer.vue?vue&type=script&lang=js"
export * from "./create-customer.vue?vue&type=script&lang=js"
import style0 from "./create-customer.vue?vue&type=style&index=0&id=6d1af652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1af652",
  null
  
)

export default component.exports